import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { useProject } from '../contexts/ProjectContext';
import UserDropdown from './UserDropdown';
import ProjectSettings from './ProjectSettings';

const NavbarContainer = styled.nav`
  height: 48px;
  background: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  cursor: pointer;
  transition: color ${({ theme }) => theme.transitions.base};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const LogoImage = styled.img`
  width: 100px;
  height: auto;
  object-fit: contain;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Navbar: React.FC = () => {
  const { user } = useAuth();
  const { currentProject } = useProject();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <NavbarContainer>
      <LeftSection>
        <Logo onClick={handleLogoClick}>
          <LogoImage src="/images/logo.png" alt="Logo" />
          インシデントレポートツール
        </Logo>
      </LeftSection>
      
      <RightSection>
        {user && (
          <UserDropdown 
            user={user} 
            onSettingsClick={() => setIsSettingsOpen(true)}
          />
        )}
      </RightSection>

      {isSettingsOpen && (
        <ProjectSettings
          isOpen={isSettingsOpen}
          onClose={() => setIsSettingsOpen(false)}
        />
      )}
    </NavbarContainer>
  );
};

export default Navbar;